export const SECTION_NUMBER = 6
export const SCORE_DENOMINATOR = 100

export const CHART_VIEW_BOX = '0 0 343 221'
export const CHART_CURVE_PATH = 'M0 145.5 C230.741 128.196 302 42 343 0'
export const CHART_BASELINE_Y = 220
export const CHART_CURVE_COLOR = '#6E68EE'
export const CURVE_DRAW_DURATION_MS = 1200
export const MARKER_TRAVEL_DURATION_MS = 600

export const KIND_OF_LEARNING_LABELS: Record<string, string> = {
  games: 'games',
  visual: 'visual',
  interactive: 'interactive',
  practical: 'practical',
  audio: 'audio',
  text: 'text',
}

export const DAILY_PACE_I18N_KEYS: Record<string, string> = {
  casual: 'onboarding.quizSingleChoice.dailyGoal.options.firstAdditional',
  regular: 'onboarding.quizSingleChoice.dailyGoal.options.secondAdditional',
  serious: 'onboarding.quizSingleChoice.dailyGoal.options.thirdAdditional',
  determined: 'onboarding.quizSingleChoice.dailyGoal.options.fourthAdditional',
}

export const FOCUS_GOAL_I18N_KEYS: Record<string, string> = {
  lessThanOneHour: 'onboarding.learningProfile.focusGoal.lessThanOneHour',
  oneToThreeHours: 'onboarding.learningProfile.focusGoal.oneToThreeHours',
  mostOfMyFreeTime: 'onboarding.learningProfile.focusGoal.mostOfMyFreeTime',
}
